import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

/**
 * ActionMenuPortal - Renders an action menu via a portal to avoid parent container overflows.
 * Implements a transparent backdrop to handle "click outside" behavior.
 */
const ActionMenuPortal = ({ isOpen, anchorRect, onClose, children }) => {
    const [coords, setCoords] = useState({ top: 0, left: 0 });

    useEffect(() => {
        if (isOpen && anchorRect) {
            const menuWidth = 180; // Unified menu width
            const menuHeight = 200; // Expected max height
            const padding = 8;

            let top = anchorRect.bottom + window.scrollY;
            let left = anchorRect.right - menuWidth + window.scrollX;

            // Check if vertical overflow on bottom
            if (top + menuHeight > window.innerHeight + window.scrollY) {
                top = anchorRect.top + window.scrollY - menuHeight - padding;
            }

            // Check horizontal overflow
            if (left < padding) left = padding;
            if (left + menuWidth > window.innerWidth + window.scrollX - padding) {
                left = window.innerWidth + window.scrollX - menuWidth - padding;
            }

            setCoords({ top, left });
        }
    }, [isOpen, anchorRect]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <>
            {/* Transparent backdrop to catch clicks outside the menu */}
            <div
                className="action-menu-backdrop"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    zIndex: 9998,
                    background: 'transparent'
                }}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClose();
                }}
            />
            {/* The actual menu container */}
            <div
                className="action-portal-wrapper"
                style={{
                    position: 'absolute',
                    top: `${coords.top}px`,
                    left: `${coords.left}px`,
                    zIndex: 9999,
                    width: '180px' // Unified width
                }}
                onClick={(e) => {
                    // Stop propagation to prevent the backdrop from closing the menu
                    // when clicking inside the menu items.
                    e.stopPropagation();
                }}
                onMouseLeave={() => {
                    // Optional: Close on mouse leave for a smoother experience?
                    // The user specifically asked for click outside, so let's stick to that.
                }}
            >
                {children}
            </div>
        </>,
        document.body
    );
};

export default ActionMenuPortal;
